import React, { useEffect,useState,useRef } from "react";
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import labelIcon from 'assets/icons/manual_label.svg'
import arrowViewAllIcon from 'assets/icons/arrow_viewall_manual.svg'
import arrowViewTopicIcon from 'assets/icons/arrow_topic_manual.svg'
import axios from "axios";
import "./manual.scss"
import { Link , useNavigate } from "react-router-dom";


const ManualTopic = ()=>{
    const { t } = useTranslation();
    const hash = window.location.hash;
    const navigate = useNavigate(); 

    const { mainCategoryId,parentCategoryId,topicId } = useParams();
    const [sideMainCategories,setSideMainCategories] = useState()
    const [currentTopicId,setCurrentTopicId] = useState()
    const refs = useRef({}); // Store dynamic refs in an object

    const [manualContent,setManualContent] =  useState()
    const setRef = (id) => (el) => {
      refs.current[id] = el; // Assign ref dynamically based on the id
    };

    const scrollTo = (id) => {
        refs.current[id]?.scrollIntoView({ behavior: "smooth", block: "center" });
      };

      


useEffect(()=>{
    
    const main_categories = async ()=>{
        
        const postData = await axios.get(`https://gis247.net/wp-json/content-api/manual/get-manual-content-by-id?post_id=${topicId}`);
        let categories ;
        
        if(parentCategoryId){

            categories = await axios.get(`https://gis247.net/wp-json/content-api/manual/get-manual-main-categories-with-sub-by-id?mainCatId=${parentCategoryId}`);
            const categories_id_data = await axios.get(`https://gis247.net/wp-json/content-api/manual/get-manual-categories-by-id?mainCatId=${mainCategoryId}`);
console.log(categories_id_data.data[0],'categories_id_data.data[0]')

            if(categories_id_data.data[0].sub_category.length>0){
                console.log(categories_id_data.data[0],'categories_id_data.data')
                console.log(categories,'categories')

                let categories_data = categories_id_data.data[0]
              
                setSideMainCategories({main_category_name:categories_id_data.data[0].name,...categories_data});
            }else{
                console.log(categories.data,'categories.data')
                console.log(categories.data.sub_category,'categories.data.sub_category')
                console.log(categories.data.sub_category.filter((v)=> {return parseInt(v.parent_id) === parseInt(parentCategoryId) } ),'filter')
                const filter_data = await categories.data.sub_category.filter((v)=> {return parseInt(v.parent_id) === parseInt(parentCategoryId) } );
                console.log(filter_data,'filter_data')
                if(filter_data)
                setSideMainCategories({
                    main_category_name : categories.data.main_category_name,
                    main_category_id : categories.data.main_category_id,
                    sub_category : filter_data
                });

            }

        }else{

            categories = await axios.get(`https://gis247.net/wp-json/content-api/manual/get-manual-main-categories-with-sub-by-id?mainCatId=${mainCategoryId}`);
        
            setSideMainCategories(categories.data);


        }
       
        console.log(postData.data,'postData.data')
        setManualContent(postData.data)

        setCurrentTopicId(postData.data.id)
        console.log(categories.data);
    }
    main_categories()
    if (hash) {
        const elementId = hash.substring(1); // Remove the '#'
        console.log(elementId,'elementId')
        scrollTo(elementId)
    }

}, [window.location.hash,window.location,topicId])


    return (
        <>
        <div className="main-content-wrapper-body">
            <div className="main-content-wrapper-body-top-bar d-flex align-items-center justify-content-between">
                <div className="main-content-wrapper-body-top-bar-left">
                <h1 className="main-content-wrapper-body-top-bar-left-heading fw-semibold mb-0">
                    
                  
                   <span className="non_active"> <Link to="/app/admin/manual">{t("User Manual")}  </Link> </span>  
                 
                    <span className="arrow-suparate">                <img src={arrowViewTopicIcon} className="arrow_img"/>
                    </span> 
                    <span className="active">{sideMainCategories?sideMainCategories.main_category_name:""}</span>
                </h1>
                </div>
    
           
                
            </div>    
    
                 <div className="manual_view_wrp">
                    <div className="row">
                                <div className="col-md-3">
                                        <ul className="side_list_manual_categories">
{sideMainCategories?sideMainCategories.sub_category.map((v)=>{
    return (
        <li>
        <h4><img src={labelIcon} className="label_side"/>{v.name}</h4>
      
        {v.post?v.post.map((vp)=>{
            const linkTopic = v.sidebar_style === "link_to_topic" ? `/app/admin/view-manual/topic/${mainCategoryId}/${v.parent_id}/${vp.id}` : `${vp.section_title}`
            return (
                <span className="topic_link">
                <img src={arrowViewTopicIcon} className="label_side"/>
                {v.sidebar_style === "link_to_topic" ? 
                <span onClick={()=>{
                    setCurrentTopicId(vp.id)
                    navigate(linkTopic, { replace: true })
                }}>
                    {vp.heading_th}
                </span>
                // <Link to={linkTopic} onClick={()=>{
                //     setCurrentTopicId(vp.id)
                // }}>
                // {vp.heading_th}
                // </Link>
                 :
                 
                <span onClick={() => scrollTo(linkTopic)}>
                {vp.heading_th}
                </span>
                 }
            </span>
            )
        }):""}
       
    </li>

    )
}):""}
                                     

                                        </ul>
                                </div>
    
                                <div className="col-md-9 ">
                                <div className="manual_content_wrp">

                                    <h2 className="category_header">{sideMainCategories?sideMainCategories.main_category_name:""}</h2>
                             
        {manualContent?

      <div className="manual_description"  id={manualContent.section_title} >
           
       <h5>{manualContent.heading_en}</h5>
       <div className="manual_content"  dangerouslySetInnerHTML={{ __html: manualContent.content_en }} >
           
       </div>
   </div>
   
            
        
        
        
        :""}
         
                                </div>
                                </div>
                    </div>
                   
    
                </div>    



          </div>        
            </>
    )
}

export default ManualTopic;